import { useCallback, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordAction } from "../authActions";
import { getPasswordResetErrorSelector, getPasswordResetOkSelector } from "../authSelectors.js";
import { useLocation } from "react-router";
import useEffectOnce from "../../../hooks/useEffectOnce.js";
import appHistory from "../../../app/appHistory";
import RouterPaths from "../../../app/routePaths";
import FormPasswordEye from "../../../components/PasswordTooltip/FormPasswordEye";

function Reset() {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const passwordResetOk = useSelector(getPasswordResetOkSelector);
    const passwordResetError = useSelector(getPasswordResetErrorSelector);

    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');

    useEffect(() => {
        if (passwordResetOk) {
            appHistory.push(RouterPaths.login);
        }
    }, [passwordResetOk]);

    useEffectOnce(() => {
        const params = new URLSearchParams(search);
        setEmail(params.get('email'));
        setCode(params.get('code'));
        dispatch(resetPasswordAction({
            check: true,
            email: params.get('email'),
            code: params.get('code'),
        }));
    });

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        dispatch(resetPasswordAction({
            email,
            code,
            new_password: e.target.querySelector('[name=new_password]').value,
            new_password_repeat: e.target.querySelector('[name=new_password_repeat]').value,
        }));
    }, [code, dispatch, email]);

    return <>
        <Form.Group className="mb-5 mt-2">
            <h4 className="text-center">New password</h4>
        </Form.Group>
        <Form onSubmit={submitHandler}>
            <Form.Group className={'mb-4'}>
                <FormPasswordEye
                    name="new_password"
                    placeholder={'New password'}
                    required
                />
            </Form.Group>
            <Form.Group className={'mb-4'}>
                <FormPasswordEye
                    name="new_password_repeat"
                    placeholder={'Re-enter password'}
                    required
                />
            </Form.Group>

            {
                !!passwordResetError && <>
                    <p className={'text-danger'}>
                        {passwordResetError}
                    </p>
                </>
            }

            <div className="d-grid mb-2">
                <Button variant={'primary'} type="submit" className="mb-4">
                    Save
                </Button>
            </div>
        </Form>
    </>
}

export default Reset;
